"use strict";

exports.__esModule = true;
exports.GenericLookupClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _constants = require("../constants");
const GenericLookupClient = {
  /**
   * @description Return the orders of a customer .
   * @returns {Promise}
   */
  async fetch() {
    const requestId = 'HOTEL_CHAINS';
    const {
      data
    } = await _http.$http.get(requestId, _constants.ENDPOINTS.GET_GENERIC_LOOKUP);
    return data;
  },
  async fetchResources() {
    const requestId = 'FETCH_RESOURCES';
    const {
      data
    } = await _http.$http.get(requestId, _constants.ENDPOINTS.GET_RESOURCES);
    return data;
  }
};
exports.GenericLookupClient = GenericLookupClient;